import { IErrorModalConfig, PaymentErrorsE } from './error-modal.types'

import { ReactComponent as Clock2Icon } from 'primsell-shared-layer/assets/icons/clock2.svg'
import { ReactComponent as AlreadyBought } from 'primsell-shared-layer/assets/icons/payment-info/already-bought.svg'

export const errorModalConfig: Record<PaymentErrorsE, IErrorModalConfig> = {
  [PaymentErrorsE.PURCHASE_LIMIT_EXCEEDED]: {
    icon: AlreadyBought,
    title: 'You have already purchased <br/> [Collection name] NFT.',
    description: 'This collection is limited to 1 item.',
  },
  [PaymentErrorsE.PURCHASE_ORDER_IN_PROGRESS]: {
    icon: Clock2Icon,
    title: 'Your payment is in progress',
    description: 'Please note that this collection is limited to 1 item. <br/> The process can take up to 5 minutes...',
  },
}
